import { render } from "./ChangeLogList.vue?vue&type=template&id=4556d98b"
import script from "./ChangeLogList.vue?vue&type=script&lang=js"
export * from "./ChangeLogList.vue?vue&type=script&lang=js"

import "./ChangeLogList.vue?vue&type=style&index=0&id=4556d98b&lang=css"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__